import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import * as FPT from '../utility/fpt'
import TemplateData from '../utility/getTemplateData'
import { localsMessages } from '../utility/getTemplateData'

const messages = localsMessages('common/cancelAndReturn')

class CancelAndReturn extends React.Component {

    constructor() {
        super();
        const { label: { return: returnLabel = '' } = {} } = messages || {};
        this.state = {
            returnLabel: returnLabel,
            displayMe : TemplateData.charityCancelUrl ? true : false
        };
    }

    handleCancel(){
        FPT.trackLinkClick('cancel');
        let cancelurl = TemplateData.charityCancelUrl;
        window.location.href = cancelurl;
    }

    render() {

        let labelreturn = this.state.returnLabel;
        labelreturn = labelreturn.replace('{orgName}', TemplateData.donationName);

        return (
            <div>
                {this.state.displayMe ?
                    <div className="col-xs-12 col-sm-12 col-md-12 text-center pp_cancel_btn_wrapper">
                        <a href="#"
                            className="btn btn-primary pp_cancel_btn"
                            style={{ padding: 0}}
                            id="cancelReturnBtn"
                            onClick={this.handleCancel.bind(this)}
                            dangerouslySetInnerHTML={{__html : labelreturn}}>
                        </a>
                    </div> : null
                }
            </div>
        );
    }
}

export default CancelAndReturn;



// WEBPACK FOOTER //
// ./components/cancelAndReturn.js